<template>
  <div class="about">
    <h1>404 Not Found</h1>
  </div>
</template>
